import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import qs from 'query-string'
import { LOGIN_PATH, FORGOT_PASSWORD_PATH } from 'routing/constants'
import { StyledChangePasswordForm, ChangePasswordPageTitle, ChangePasswordInputHint } from '../style'
import PasswordInput from 'components/PasswordInput'
import { showErrorToast, showSuccessToast } from 'utils/toast'
import Button from 'components/Button'
import { requestUserChangePassword } from 'api/user'
import { ResetPasswordFooterWrapper, ResetPasswordFooterText, StyledLink } from '../../ForgotPassword/style'
import validatorPassword from 'validators/password'

const ChangePasswordForm = () => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState({ field: '', error: '' })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const token = qs.parse(useLocation().search).token
  const history = useNavigate()

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value)
  }

  const cleanForm = () => {
    setPassword('')
    setConfirmPassword('')
    setError({ field: '', error: '' })
  }

  const isFormValid = () => {
    if (!password.length && !confirmPassword.length) {
      setError({ field: 'password', error: 'enterAndConfirmNewPassword' })
      return false
    }

    if (!password.length) {
      setError({ field: 'password', error: 'pleaseEnterNewPassword' })
      return false
    }

    if (!confirmPassword.length) {
      setError({ field: 'confirmPassword', error: 'confirmPasswordEmpty' })
      return false
    }

    if (!validatorPassword(password)) {
      setError({ field: 'password', error: 'passwordIsInvalid' })
      return false
    }

    if (password !== confirmPassword) {
      setError({ field: 'confirmPassword', error: 'passwordsNoMatchInvalid' })
      return false
    }

    setError({ field: '', error: '' })
    return true
  }

  const submitForm = async () => {
    if (!isFormValid()) {
      return
    }
    setIsFormSubmitted(true)

    try {
      //const response = await requestUserChangePassword({ token, password })

      const response = await requestUserChangePassword({ token, password })

      if (response.error === 'alreadyUsedOrExpired') {
        history(FORGOT_PASSWORD_PATH)
      }
      if (response.error) {
        showErrorToast(<FormattedMessage id={response.error} />, 'showBorder')
        setIsFormSubmitted(false)
      } else {
        cleanForm()
        showSuccessToast(<FormattedMessage id="passwordChangeSuccessful" />, 'showBorder')
        setIsFormSubmitted(false)
      }
    } catch (e) {
      showErrorToast(<FormattedMessage id="somethingWentWrong" />, 'showBorder')
    }
  }

  return (
    <>
      <StyledChangePasswordForm>
        <ChangePasswordPageTitle data-test="legend">
          <FormattedMessage id="changePassword" />
        </ChangePasswordPageTitle>
        <ChangePasswordInputHint>
          <FormattedMessage id={'passwordHint'} />
        </ChangePasswordInputHint>
        <PasswordInput
          field="password"
          value={password}
          placeholder="newPasswordPlaceholder"
          onChange={handlePasswordChange}
          error={error}
        />
        <PasswordInput
          field="confirmPassword"
          value={confirmPassword}
          placeholder="confirmNewPasswordPlaceholder"
          onChange={handleConfirmPasswordChange}
          error={error}
          margin="0px"
        />
        <Button onClick={submitForm} isPending={isFormSubmitted} marginTop="32px" width='100%' type='primary'>
          <FormattedMessage id="changePassword" />
        </Button>
        <ResetPasswordFooterWrapper data-test="reset-password-footer">
          <ResetPasswordFooterText data-test="label">
            <FormattedMessage id="rememberYourPassword" />
          </ResetPasswordFooterText>
          <ResetPasswordFooterText data-test="sign-in">
            <StyledLink to={LOGIN_PATH}>
              <FormattedMessage id="signIn" />
            </StyledLink>
          </ResetPasswordFooterText>
        </ResetPasswordFooterWrapper>
      </StyledChangePasswordForm>
    </>
  )
}

export default ChangePasswordForm
